<div class="question-container" [formGroup]="group" [ngClass]="{active: isSelected, interviewQuestion: interviewMode}">
  <div [ngClass]="isConfigInvalid()?'invalid-question':''">
    <div class="question-header" *ngIf="!interviewMode" (click)="selectQuestion()">
      <button type="button" class="btn btn-link float-start" (click)="expanded = !expanded">
        <i aria-hidden="true" class="fa" [ngClass]="{'fa-angle-right': !expanded, 'fa-angle-down': expanded}"></i>
      </button>
      <span class="question-mapkey">
        {{config.mapKeyName}}
      </span>
      <span class="question-mapkey float-end pe-2">
        {{config.answerTypeName}}
      </span>
    </div>
    <div class="question-body" *ngIf="expanded && !useCondensedView">
      <div class="question-text rendered-quill-content ql-editor-updated" [innerHTML]="questionText"></div>
      <div class="help-text rendered-quill-content ql-editor-updated" [innerHTML]="helpText"
        *ngIf="config.helpText?.length"></div>
      <div class="question-form">
        <mat-form-field >
          <input matInput [matDatepicker]="picker" [placeholder]="config?.Placeholder" [formControlName]="pickerFieldName" [attr.data-test-input-type]="inputType"
            (focus)="onFocus()" (dateChange)="onDateChange()" (blur)="onDateChange($event)" [min]="minDate" [max]="maxDate" [disabled]="isReadOnly()"
            [readonly]="isReadOnly()" appMaskDate>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker [disabled]="isReadOnly()"></mat-datepicker>
          <mat-error *ngIf="group.get(pickerFieldName)?.hasError('required')">required</mat-error>
          <mat-error *ngIf="group.get(pickerFieldName)?.hasError('matDatepickerMin')">Minimum value is {{minDate}}</mat-error>
          <mat-error *ngIf="group.get(pickerFieldName)?.hasError('matDatepickerMax')">Maximum value is {{maxDate}}</mat-error>
          <mat-error *ngIf="group.get(pickerFieldName)?.hasError('validationError')">{{group.get(config.id)?.errors.validationError}}</mat-error>
        </mat-form-field>
                  
      </div>
      <app-field-details [question]="config" [form]="group" [readOnlyMode]="isReadOnly()"></app-field-details>
    </div>
    <div class="condensed-view" *ngIf="expanded && useCondensedView" [ngClass]="config.helpText?.length ? 'condensed-hint-view' : 'no-hint'">
      <div>
        <mat-form-field>
          <mat-label [innerHTML]="questionText" class="condensed-label-view"></mat-label>
          <input matInput [matDatepicker]="picker" [placeholder]="config?.Placeholder" [formControlName]="pickerFieldName" [attr.data-test-input-type]="inputType"
            (focus)="onFocus()" (dateChange)="onDateChange()" (blur)="onDateChange($event)" [min]="minDate" [max]="maxDate" [disabled]="isReadOnly()"
            [readonly]="isReadOnly()" appMaskDate>
          <mat-hint  [innerHTML]="helpText"></mat-hint>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker [disabled]="isReadOnly()"></mat-datepicker>
          <mat-error *ngIf="group.get(pickerFieldName)?.hasError('required')">required</mat-error>
          <mat-error *ngIf="group.get(pickerFieldName)?.hasError('matDatepickerMin')">Minimum value is {{minDate}}</mat-error>
          <mat-error *ngIf="group.get(pickerFieldName)?.hasError('matDatepickerMax')">Maximum value is {{maxDate}}</mat-error>
          <mat-error *ngIf="group.get(pickerFieldName)?.hasError('validationError')">{{group.get(config.id)?.errors.validationError}}</mat-error>
        </mat-form-field>                  
      </div>
    </div>    
  </div>
</div>
